import { FunctionComponent } from "react";
import styles from "./title.module.scss";

const Title: FunctionComponent<{ children: string; className?: string }> = ({
  children,
  className = "",
}) => {
  const titleClass = className + styles.title;
  return <p className={titleClass}>{children}</p>;
};

export default Title;
